import { useState } from "react";
import { Flex, Text } from "styles/utility-components";

import ContentLibraryAiChatModal from "components/content_library/ContentLibraryAiChatModal";
import { CreateContentLibraryFolderModal } from "components/content_library/modals/CreateContentLibraryFolderModal";
import UploadContentLibrary from "components/content_library/UploadContentLibrary";
import { ProviderType } from "components/integrations/managed_integrations/types";
import Modal from "components/ui/modal/Modal";
import QuickActionButton from "components/ui/quick_action_button/QuickActionButton";

type Props = {
  hasDocuments: boolean;
  hasPermissionsToModify: boolean;
  provider: ProviderType | "uploads";
  uiPath: string | undefined; // Only present if we're already in a folder
};

export default function ContentLibraryActionCards({
  hasDocuments,
  hasPermissionsToModify,
  provider,
  uiPath,
}: Props): JSX.Element {
  const [isUploadModalOpen, setUploadModalOpen] = useState(false);
  const [isAskAiModalOpen, setIsAskAiModalOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  return (
    <>
      <Flex gap={16} aria-label="Content library action items">
        {hasDocuments && (
          <QuickActionButton
            icon="stars2"
            text="Ask Stotles AI"
            onClick={() => setIsAskAiModalOpen(true)}
          />
        )}
        {hasPermissionsToModify && (
          <QuickActionButton
            icon="folderPlus"
            text="New folder"
            onClick={() => setIsCreateModalOpen(true)}
          />
        )}
        {hasPermissionsToModify && (hasDocuments || uiPath) && (
          <QuickActionButton
            icon="upload01"
            text="Upload documents"
            onClick={() => setUploadModalOpen(true)}
          />
        )}
      </Flex>

      <Modal
        open={isUploadModalOpen}
        showCloseButton={false}
        onOpenChange={setUploadModalOpen}
        padding={40}
      >
        <Flex flexDirection="column" gap={24}>
          <Text h1>Upload documents</Text>
          <UploadContentLibrary onClose={() => setUploadModalOpen(false)} uiPath={uiPath} isModal />
        </Flex>
      </Modal>

      <ContentLibraryAiChatModal
        isOpen={isAskAiModalOpen}
        onClose={() => setIsAskAiModalOpen(false)}
        provider={provider}
        uiPath={uiPath}
      />
      <CreateContentLibraryFolderModal
        isOpen={isCreateModalOpen}
        onOpenChange={(open) => setIsCreateModalOpen(open)}
        uiPath={uiPath}
      />
    </>
  );
}
